import * as fromClientSidePermissionsStates from './client-side-permission.states';

export const clientSidePermissionFeatureKey = 'clientSide'

export interface ClientSidePermissionStates {
  clientSide: fromClientSidePermissionsStates.ClientSidePermissionsState
}
